import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import ModalUploadMetaFailed from './ModalUploadMetaFailed';

function mapStateToProps(state, ownProps) {
  return {
    fileName: ownProps.bodyValues.fileName,
  };
}

export default compose(
  connect(mapStateToProps),
  withEscHandler,
  injectIntl,
)(ModalUploadMetaFailed);
